export default __webpack_public_path__ + "static/reactathon-sf-inline-logo-dark-c5abf79d344c5d54f8a8ef3dc93f596a.svg";